// extracted by mini-css-extract-plugin
export default {"faqList":"faq_faqList__c333-"};